<template>
   <div id="media_picker_header">
       <div class="media-picker-wrapper">
         <div class="media-picker-banner col-md-8"> 
            <span class="mp-title">Media Picker</span>

            <div class="mp-btn-row-container" v-if="typeOptions.length > 0">
               <!-- <div class="mp-btn-row">
                  <a @click="handleClick(1)" :class="{selected: selectedType == 1, disabled: !isActiveType(1)}">Images</a>
                  <a @click="handleClick(2)" :class="{selected: selectedType == 2, disabled: !isActiveType(2)}">Movies</a>
                  <a @click="handleClick(10)" :class="{selected: selectedType == 10, disabled: !isActiveType(10)}">Instances</a>
                  <a @click="handleClick(6)" :class="{selected: selectedType == 6, disabled: !isActiveType(6)}">Feeds</a>
                  <a @click="handleClick(3)" :class="{selected: selectedType == 3, disabled: !isActiveType(3)}">Audio</a>
               </div> -->
               <base-dropdown
                  :options="typeOptions"
                  @newOption="handleNewOption">
               </base-dropdown>
            </div>

            <div v-if="!isBlock" class="mp-zone-type" >
               <span class="asset-type">{{getAssetString(activeType)}}</span> Options
            </div>
         </div>
      </div>
      <div class="close-picker" @click="closePicker()">
         X
      </div>
   </div>
</template>

<script>
import BaseDropdown from './../BaseDropdown';
import { mapActions, mapState } from 'vuex';

export default {

   data() {
      return {
         showDropdown: false,
         typeOptions: [],
         activeType: ''
      }
   },
   
   props: {
      assetType: Number | Array,
      assetId: Number,
      selectedType: Number,
      isBlock: Boolean
   },

   computed: {
      ...mapState('global', [
         'mpAssetType',
         'currSelectedAssetType'
      ])
   },

   created() {
      this.getOptions();
      this.activeType = this.mpAssetType instanceof Array ? this.mpAssetType[0] : this.mpAssetType;
   },

   methods: {
      ...mapActions('global', [
         'changeCurrAssetType',
         'closeMediaPicker'
      ]),

      getOptions() {
         if (this.mpAssetType instanceof Array) {
            for (let type of this.mpAssetType) {
               let typeObj = {};
               typeObj.id = type;
               typeObj.text = this.getAssetString(type);
               this.typeOptions.push(typeObj);
            }
         }
      },

      isActiveType(type) {
         if (this.mpAssetType instanceof Array) {
            return this.mpAssetType.includes(type);
         }
      },

      handleClick(type) {
         if (this.isActiveType(type)) {
            this.$parent.$emit('typeClicked', type);
         }
      },

      closePicker() {
         //TODO: change this
         // this.$parent.$emit('close'); // Schedule
         // this.$parent.$emit('CloseMediaPicker'); // Create
         this.closeMediaPicker({});
      },

      handleNewOption(type) {
         // if (this.isActiveType(type)) {
         //    this.activeType = type;
         //    this.$parent.$emit('typeClicked', type);
         // }
         this.changeCurrAssetType({type});
      },
   },

   watch: {
      mpAssetType() {
         this.typeOptions = [];
         this.getOptions();
         this.activeType = this.mpAssetType instanceof Array ? this.mpAssetType[0] : this.mpAssetType;
      }
   },

   components: {
      BaseDropdown
   }
}
</script>

<style lang="scss" scoped>
#media_picker_header {
   z-index: 15;
   color: white;

   .media-picker-wrapper {
      padding-left: 15px;
   }

   .media-picker-banner {
      padding: 27px 0 4px 0;
      display: inline-block;
   }

   .close-picker {
      float: right;
      margin-right: 10px;
      margin-top: 10px;
      background: $error-red;
      border-radius: 30px;
      padding: 2px 6px;
      font-size: 10px;
      color: white;
      position: absolute;
      right: 0;
      top: 0;

      &:hover {
         cursor: pointer;
      }
   }

   .mp-title {
      margin-right: 25px;
      font-size: 22px;
   }

   .mp-btn-row-container {
      display: inline-block;

      .mp-btn-row {
         display: flex;
         align-items: center;

         a {
            color: #fff;
            font-size: 14px;
            text-transform: uppercase;

            &.selected {
               color: $bard-gold;
               border: 1px solid $bard-gold;
               padding: 2px 10px;
            }

            &.disabled {
               color: #5a626d;

               &:hover {
                  cursor: default;
               }
            }

            &:not(:last-child) {
               margin-right: 60px;
            }
         }
      }
   }

   .mp-zone-type {
      font-size: 14px;
      .asset-type { 
         text-transform: capitalize;
      }
   }
}

</style>
